<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="content" v-loading="loading">
        <div class="timeline">
          <div
            class="time-item"
            v-for="v in newsListCatData"
            :key="v.id"
            @click="onRouter(v)"
          >
            <div class="date-box">
              <div class="date">{{ v.firedate | timeFormatMD }}</div>
              <div class="year">{{ v.firedate | timeFormatYear }}</div>
            </div>
            <div class="time-info">{{ v.name }}</div>
          </div>
        </div>
        <div class="more">
          <div class="more-icon">
            <img src="~@a/img/time.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";
import { mapMutations } from "vuex";
import LStore from "store";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      newsListCatData: [],
      swiperImgs: [],
      loading: false
    };
  },
  components: {
    Swiper
  },
  created() {
    this.topingAll();
    this.productCat();
    this.newsListCat();
  },
  methods: {
    ...mapMutations(["PRODUCT_DATA"]),
    productCat(params) {
      API.productCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.PRODUCT_DATA(res.data);
          LStore.set("productData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 2)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsListCat(params) {
      this.$set(this, "loading", true);
      API.newsListCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "newsListCatData", res.data.data);
          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsCasesCat(params) {
      API.newsCasesCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
            onClose: () => {}
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onRouter(v) {
      this.$router.push({
        path: "list",
        query: {
          id: v.id,
          casescatId: v.casescat_id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  line-height: initial;

  .more {
    display: flex;
    justify-content: center;
    margin: 20px 0 40px;

    .more-icon {
      width: 20px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .breadcrumb-com {
    padding: 0 10px;
  }
}
</style>
